import { memo } from 'react';

import { Box, Text } from '@zillow/constellation-10';

import { StyledIconPlaceholder } from '../StyledComponents';

type Props = {
  value?: string | Array<JSX.Element | null>;
  customNoneText?: string;
  showIconPlaceholder?: boolean;
  customDisplayComponent?: JSX.Element | null;
  className?: string;
};

const FieldValueDisplay = ({
  value = '',
  showIconPlaceholder = true,
  customNoneText = '',
  customDisplayComponent = null,
  className = '',
}: Props): JSX.Element => {
  let textColor: 'text.subtle' | 'text.neutral' = 'text.subtle';
  let displayValue: string | Array<JSX.Element | null> = value === '' && customNoneText ? customNoneText : 'None';

  if (value && value.length) {
    textColor = 'text.neutral';
    displayValue = value;
  }

  return (
    <Box css={{ display: 'flex', alignItems: 'center' }}>
      {showIconPlaceholder && <StyledIconPlaceholder />}
      {customDisplayComponent ? (
        customDisplayComponent
      ) : (
        <Text color={textColor} css={{ wordBreak: 'break-word', whiteSpace: 'break-spaces' }} className={className}>
          {displayValue}
        </Text>
      )}
    </Box>
  );
};

export default memo(FieldValueDisplay);
